import { useCallback, useState } from 'react';
import _ from 'lodash';

export default ({
    ownerVM
}) => {
    const [, updateState] = useState();
    const [accordions, updateAccordions] = useState({});
    const [openedAccordion, updateOpenedAccordion] = useState();

    const accordionCallbackProps = useCallback(() => {
        return Object.values(accordions).reduce((accordion, newOverrideProps) => {
            return {
                ...newOverrideProps,
                ...accordion
            };
        }, {}); 
    }, [accordions]);

    const handleOpenedAccordion = (accordionLevel, newAccordionId) => (currentlyOpen) => {
        // if a new one is opened, close the others
        updateOpenedAccordion(currentlyOpen[0]);
        if (currentlyOpen && accordions[accordionLevel]) {
            accordions[accordionLevel] = Object.entries(accordions[accordionLevel])
                .reduce((newAccordionList, [key, accordionToClose]) => {
                    return {
                        ...newAccordionList,
                        [key]: {
                            // remove the defaultOpenedId
                            onUpdateAccordionStates: accordionToClose.onUpdateAccordionStates
                        }
                    };
                }, {});
        }

        const callbackProps = {
            defaultOpenedId: currentlyOpen[0],
            onUpdateAccordionStates: handleOpenedAccordion(accordionLevel, newAccordionId)
        };
        const accordionPath = `${accordionLevel}.${newAccordionId}`;
        _.set(accordions, accordionPath, callbackProps);
        updateAccordions(accordions);
    };

    const openAccordions = (callbackProps) => {
        const { path, accordionDetails, iterableIndex } = callbackProps;
        if (accordionDetails) {
            const data = _.get(ownerVM, `${path}.value`);
            const currentIndex = ((data && data.length) || 1) - 1;
            const { accordionId, accordionCardId, accordionLevel } = accordionDetails;
    
            const newAccordionId = iterableIndex && iterableIndex !== '{_index_}' ? `${accordionId}${iterableIndex}` : accordionId;
            handleOpenedAccordion(accordionLevel, newAccordionId)([`${accordionCardId}${currentIndex}`]);
        }
        updateState({});
    };

    const renderKey = useCallback(
        () => {
            return `opened_${openedAccordion}`;
        },
        [openedAccordion]
    );

    return {
        openAccordions,
        accordionCallbackProps,
        renderKey
    };
};